import { ComponentProps, useMemo } from 'react';

import { CurrencyAccountSelect } from '@/features/account-select';

import { useTotalBalanceStore } from '@/entities/currency-account';
import { WidgetSchemaAccount } from '@/entities/widget';

import { ICurrencyAccount, cn } from '@/shared/lib';
import { AppImage, ArrowOpener, Heading, Skeleton } from '@/shared/ui';

import { useCustomizationStore } from '../model/store';

interface AccountWidgetProps {
  widget?: WidgetSchemaAccount;
  accountSelectProps?: Omit<
    ComponentProps<typeof CurrencyAccountSelect>,
    'selected' | 'onSelect'
  >;
  imageClassName?: string;
  onAddAccount?: VoidFunction;
  account: ICurrencyAccount;
  setAccount: (acc: ICurrencyAccount) => void;
  totalBalance: number;
  isTotal?: boolean;
}
export const AccountWidget = ({
  onAddAccount,
  accountSelectProps,
  imageClassName,
  account,
  setAccount,
  //totalBalance = 0,
  isTotal,
}: AccountWidgetProps) => {
  const widgets = useCustomizationStore((state) => state.accountsBgs);
  const totalBalance = useTotalBalanceStore(
    (state) => state.totalBalance,
  )?.amount;

  const widget = useMemo(
    () =>
      widgets?.find((i) =>
        account?.id === 'all' ? i.id === account?.id : i.id === account?.code,
      ),
    [account],
  );

  return (
    <>
      <div className="h-full w-full">
        <div className="flex h-full w-full flex-col items-center pt-[158px] md:pt-[200px]">
          <AppImage
            className={cn(
              'absolute left-0 top-0 h-full max-h-[158px] w-full rounded-6xl object-cover md:max-h-[200px]',
              imageClassName,
            )}
            fallback={
              <Skeleton className="absolute left-0 top-0 h-[158px] w-full rounded-6xl md:h-[200px]" />
            }
            src={widget?.background || account?.imgSrc}
            alt=""
          />

          <div className="flex w-full flex-col items-start justify-between gap-y-5 md:gap-y-10">
            <div
              onClick={(e) => {
                e.preventDefault();
              }}
            >
              {account && (
                <CurrencyAccountSelect
                  selected={account}
                  onSelect={setAccount}
                  onAddAccount={onAddAccount}
                  isWide
                  hasRequested={isTotal}
                  customTrigger={
                    <ArrowOpener>
                      {account?.id === 'all'
                        ? 'All accounts'
                        : `Account ${account.code}`}
                    </ArrowOpener>
                  }
                  {...accountSelectProps}
                />
              )}
            </div>

            <Heading variant="l" tag="span">
              {account?.id === 'all' ? totalBalance || '0' : account?.value}
              &#8239;
              {account?.symbol}
            </Heading>
          </div>
        </div>
      </div>
    </>
  );
};
